import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import Vform17ItemList from './Vform17ItemList.vue'

declareVconsoleComponent('vform17ItemList', Vform17ItemList, 'vform17_item_list:component')

